import * as  CmsPageActions from './cmsPages.actions';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {Action, createReducer, on} from '@ngrx/store';
import {CmsPage} from '@kion/data-models';

export const CMSPAGES_FEATURE_KEY = 'cmsPage';

export interface IPartner {
  id: string;
  termsAndConditions: string | null;
  privacyPolicy: string | null;
}

export interface CmsPagesState extends EntityState<CmsPage> {
  error?: any;
  lastCreatedId: string | null;

  isSearching: boolean;
  searchResultIds: string[];
  actualPage: string
  partnerLegals: { [id: number]: IPartner };
}

export const adapter: EntityAdapter<CmsPage> = createEntityAdapter<CmsPage>();

export interface CmsPagesPartialState {
  readonly [CMSPAGES_FEATURE_KEY]: CmsPagesState;
}

export const initialState: CmsPagesState = adapter.getInitialState({
  lastCreatedId: null,
  isSearching: false,
  searchResultIds: [],
  searchQuery: {},
  pagination: {
    page: 1,
    perPage: 10,
    totalPages: 0,
    count: 0,
    total: 0
  },
  actualPage: '',
  partnerLegals: {}
});

const CmsPagesReducer = createReducer<CmsPagesState>(
  initialState,
  on(
    CmsPageActions.loadProductCmsPageSuccess,
    CmsPageActions.loadCmsPageSuccess,
    (state, {cmsPage}) => adapter.upsertOne(cmsPage, {
      ...state,
      error: null,
      actualPage: cmsPage.label ? cmsPage.label : cmsPage.uid
    })
  ),
  on(
    CmsPageActions.loadProductCmsPageError,
    CmsPageActions.loadCmsPageError,
    CmsPageActions.loadNetworkPartnerTermsAndConditionsContentError,
    CmsPageActions.loadNetworkPartnerPrivacyPolicyContentError,
    (state, {error}) => ({...state, error: error})
  ),
  on(
    CmsPageActions.loadNetworkPartnerTermsAndConditionsContentSuccess,
    (state, {nwpId, termsAndConditions}) => {
      const newPartnerLegals = {...state.partnerLegals}
      newPartnerLegals[nwpId] = ({id: nwpId, termsAndConditions} as IPartner)
      return {
        ...state,
        error: null,
        partnerLegals: newPartnerLegals
      }
    }
  ),
  on(
    CmsPageActions.loadNetworkPartnerPrivacyPolicyContentSuccess,
    (state, {nwpId, privacyPolicy}) => {
      const newPartnerLegals = {...state.partnerLegals}
      newPartnerLegals[nwpId] = ({id: nwpId, privacyPolicy} as IPartner)
      return {
        ...state,
        error: null,
        partnerLegals: newPartnerLegals
      }
    }
  )
);

export function reducer(
  state: CmsPagesState | undefined,
  action: Action
) {
  return CmsPagesReducer(state, action);
}
